module.exports=function(o){if(void 0==o)throw TypeError("Can't call method on  "+o);return o};